var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-exam-info"},[(_setup.fetchingCourseInfo)?_c(_setup.LoadingSpinner):_c(_setup.ExamStartPage)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }